import './App.css';
import Alert from './components/Alert';
import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TexForm';
import React,{useState} from 'react';

import {
  BrowserRouter as Router,
  Routes,
  Route,
  
} from "react-router-dom";


function App() {
  const [mode, setmode] = useState("light")
  const [alert, setAlert] = useState(null)
  const showAlert=(message,type)=>{
   setAlert({
    msg:message,
    type:type
   })
   setTimeout(() => {
    setAlert(null);
   }, 1000);
  }
  const togglemode=()=>{
    if(mode === "light"){
      setmode ("dark")
      document.body.style.backgroundColor="#042743"
      showAlert("dark mode has benn anable","success ")
     // document.title = "TextUtilis - Dark Mode";
    }
    else{
      setmode("light")
      document.body.style.backgroundColor="white"
      showAlert("light mode has benn anable","success ")
      //document.title = "TextUtilis - Light Mode";
    }
  }
  return (
    <>
   <Router>
<Navbar title="Text-manager" mode={mode} togglemode={togglemode} aboutText="About"/>
<Alert alert={alert}/>
<div className="container">
<Routes>
        <Route exact path="/" element={<TextForm showAlert={showAlert} heading="Enter the text to analyes" mode={mode} />}/>
        
          <Route exact path="/about" element={<About mode={mode}/>} />
          
 
      </Routes>


</div>
</Router>

    </>
  );
}

export default App;
